import { Modal } from "../../Modal";
import React, { useState } from "react";
import { useContactsState } from "../../../contexts";
import * as http from "modules/app/utils/http";
import * as S from "./styles";
import { toast } from "react-toastify";
import ShowVideos from "./ShowVideos";
import { useTranslation } from "react-i18next";
import { getBase64 } from "modules/app/utils";

export default function VideosAttachment({
  replySources,
  answerMessage,
  setAnswerMessage,
}) {
  const [videoModal, setVideoModal] = useState();
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedVideo, setSelectedVideo] = useState(0);

  const { t } = useTranslation();
  const { currentContact } = useContactsState();

  async function sendVideos(video, index, total) {
    const parsedInt = parseInt(index) + 1;
    setVideoModal(false);

    const id = toast.info(
      t("Chat:video_attachment.sending_queue", {
        user: currentContact.name,
        total: total,
        current: parsedInt,
      }),
      {
        autoClose: false,
      }
    );

    try {
      await http.sendAttachment({
        customerId: currentContact.id,
        base64: video.file,
        filename: video.name,
        replySources: replySources,
        answerMessage: answerMessage,
      });

      toast.success(
        t("Chat:video_attachment.success", {
          current: parsedInt,
          total: total,
          user: currentContact.name,
        }),
        { autoClose: 4000 }
      );
      toast.update(id, {
        render: t("Chat:video_attachment.sending_queue", {
          user: currentContact.name,
          total: total,
          current: parsedInt,
        }),
        type: "info",
        isLoading: false,
        autoClose: 2000,
      });
    } catch (e) {
      toast.error(
        t("Chat:video_attachment.error", { current: parsedInt, total: total })
      );
    }
  }

  async function handleClick() {
    setLoading(true);

    for (const index in videos) {
      const video = videos[index];
      await sendVideos(video, index, videos.length);
    }

    setVideos([]);
    setAnswerMessage(null);

    setLoading(false);

    toast.success(
      t(
        "Chat:video_attachment.success_all",
        { user: currentContact.name },
        { autoClose: 9000 }
      )
    );
  }

  async function changeVideoModal(e) {
    const maxSize = 1 * 1000 * 1000 * 80;
    const file = e.target.files[0];
    e.target.value = "";

    if (file && file.size <= maxSize) {
      const base64 = await getBase64(file);
      const newFile = { file: base64, name: file.name };

      setVideos([...videos, newFile]);
      setVideoModal(true);
    } else if (file?.size > maxSize) {
      toast.warn(t("Chat:attachment.maxSize"));
    }
  }

  function handleClose() {
    setVideos([]);
    setVideoModal(false);
  }

  function handleRemoveVideo(index) {
    if (videos.length === 1) {
      setVideos([]);
      setVideoModal(false);
      setAnswerMessage(null);
    } else {
      let currentVideos = [...videos];
      currentVideos.splice(index, 1);
      setVideos(currentVideos);
    }
  }

  function handleSelectVideoPreview(index) {
    setSelectedVideo(index);
  }

  return (
    <>
      {videoModal && (
        <Modal
          size="large"
          open={videoModal}
          onClose={handleClose}
          title={t("Chat:video_attachment.title")}
        >
          <ShowVideos
            videos={videos}
            onSubmit={handleClick}
            loading={loading}
            addNewVideos={changeVideoModal}
            handleRemove={handleRemoveVideo}
            selectVideoPreview={handleSelectVideoPreview}
            selectedVideo={selectedVideo}
          />
        </Modal>
      )}

      <S.VideoButton>
        <S.VideoCameraIcon />

        <input
          type="file"
          accept="video/*"
          hidden
          onChange={changeVideoModal}
        />
      </S.VideoButton>
    </>
  );
}
